import useAsync from '../useAsync';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }

  if (!value || !value.then) {
    value = Promise.resolve(value);
  }

  return then ? value.then(then) : value;
}

var globalMethod;

function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }

    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}

export var configRequest = function configRequest(method) {
  globalMethod = method;
};

var useAPI = function useAPI(opt) {
  var requestMethod = opt.method || globalMethod || fetch;
  return useAsync(_async(function () {
    return _await(requestMethod(opt.url, opt.options), function (res) {
      return res.json && typeof res.json === 'function' ? res.json() : res;
    });
  }), [JSON.stringify(opt)], {
    manual: opt.manual,
    pollingInterval: opt.pollingInterval,
    onError: opt.onError,
    onSuccess: opt.onSuccess
  });
};

export default useAPI;